<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Telas" mark="01" color="background-green" />
    <div class="container container-telas">
      <div class="box container justify-content-center align-items-center" v-for="x in 9">
        <img :src="require('@/assets/img/telas/' + x + '.png')" width="200">
      </div>
    </div>
  </div>


</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'
export default {
  name: 'vetores',
  components: {
    titleComponent
  },
  data () {
    return {
      layout: []
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
    margin: 10px;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}
.container-telas {
    overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/telas.vue